// src/pages/atributos/index.js
import Atributos from './Atributos'
import NuevoTipoAtributo from './NuevoTipoAtributo'
import EditarTipoAtributo from './EditarTipoAtributo'
import EliminarTipoAtributo from './EliminarTipoAtributo'
import NuevoValorAtributo from './NuevoValorAtributo'
import EditarValorAtributo from './EditarValorAtributo'
import EliminarValorAtributo from './EliminarValorAtributo'

export {
	Atributos,
	NuevoTipoAtributo,
	EditarTipoAtributo,
	EliminarTipoAtributo,
	NuevoValorAtributo,
	EditarValorAtributo,
	EliminarValorAtributo
}

export default Atributos